import React from 'react';
import styled from 'styled-components';
import ServiceCard from './ServiceCard';
import { 
  FaMusic, 
  FaHeadphones, 
  FaLightbulb, 
  FaRecordVinyl
} from 'react-icons/fa';

// Import images
import {
  djServicesImage,
  speakersImage,
  lightingProductionImage,
  vinylSalesImage
} from '../assets/images';

const ServiceList = () => {
  const services = [
    {
      id: 1,
      title: 'DJ Services',
      description: 'Professional DJ services for weddings, corporate events, nightclubs, and private parties.',
      icon: <FaMusic />,
      image: djServicesImage,
      link: '/dj-services'
    },
    {
      id: 2,
      title: 'Lighting Production',
      description: 'Event lighting design, venue upgrades, and intelligent lighting programming.',
      icon: <FaLightbulb />,
      image: lightingProductionImage,
      link: '/lighting-production'
    },
    {
      id: 3,
      title: 'Vinyl & Equipment',
      description: 'Vintage vinyl records, professional DJ equipment, and audio gear sales.',
      icon: <FaRecordVinyl />,
      image: vinylSalesImage,
      link: '/vinyl-sales'
    },
    {
      id: 4,
      title: 'Audio Solutions',
      description: 'Professional audio engineering and installation with Keen Acoustic Sciences.',
      icon: <FaHeadphones />,
      image: speakersImage,
      link: '/keen-acoustic-sciences',
      isContactCard: true, // Applying the special border style
      ctaText: 'Discover Keen Acoustic Sciences'
    }
  ];

  return (
    <ServiceGrid>
      {services.map(service => (
        <ServiceCard
          key={service.id}
          title={service.title}
          description={service.description}
          icon={service.icon}
          image={service.image}
          link={service.link}
          isContactCard={service.isContactCard}
          ctaText={service.ctaText}
        />
      ))}
    </ServiceGrid>
  );
};

const ServiceGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export default ServiceList; 